module.exports = {"id":"219728","name":"Edgar Méndez","rating":"75","photo":"./data/images/photos/3/219728.png","club":{"name":"Cruz Azul","logo":"./data/images/clubs/CruzAzul.png"},"positions":["MD","MG","AG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/EdgarMendez0.json
// module id = 1171
// module chunks = 0